import RichText from './RichText';
import types from './types';
import variants from './variants';

export { types, variants };

export default RichText;
